import smartBannerConfig from "./smart-banner-config";
import apiConfig from "./api-config";
import turnstileConfig from "./turnstile-config";

export default {
  ...apiConfig,
  ...smartBannerConfig,
  ...turnstileConfig,
};
